import {Component, Input, OnChanges} from '@angular/core';
import {SimilarProductsViewModel} from "@app/presentation/components/similar-products/similar-products.view-model";

@Component({
  selector: 'ep-similar-products',
  templateUrl: './similar-products.component.html',
  styleUrls: ['./similar-products.component.scss'],
  providers: [SimilarProductsViewModel]
})
export class SimilarProductsComponent implements OnChanges {

  @Input() productsCodes: string[] | null = []

  @Input() title: string | null | undefined = null;

  @Input() displayTitle: boolean = true;

  @Input() hasAddToListButton = true;

  @Input() shownProducts: number = 3;

  similarProducts$ = this.similarProductsViewModel.similarProducts$;

  isSimilarProductsLoading$ = this.similarProductsViewModel.isSimilarProductsLoading$;

  constructor(private similarProductsViewModel: SimilarProductsViewModel) { }

  ngOnChanges(): void {
    this.similarProductsViewModel.loadSimilarProducts(this.productsCodes ?? [], this.shownProducts);
  }

}
